import placesListModule from '../placesListModule';

function gameTile(resources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.gameTile
  };
}

placesListModule.directive('gameTile', gameTile);

export default gameTile;
